import { useTranslation } from "react-i18next";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import makeStyles from "@mui/styles/makeStyles";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Tooltip from "@mui/material/Tooltip";

interface MediaButtonProps {
  tooltip?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
  },
}));

export function MediaButton(props: MediaButtonProps & IconButtonProps) {
  const { t } = useTranslation();
  const classes = useStyles();

  const color = props.disabled ? "secondary" : "primary";

  return (
    <Tooltip title={<div>{props.tooltip || t("common.viewMedia")}</div>}>
      <span>
        <IconButton color={color} {...props} className={classes.root} size="large">
          <CameraAltIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
}
